import { useEffect, useRef } from "react";
import { FAQ_INTRO, FAQ_ITEMS } from "../../data/faq";
import styles from "./FaqModal.module.scss";

function FaqModal({ onClose }) {
  const closeButtonRef = useRef(null);

  useEffect(() => {
    const previouslyFocused = document.activeElement;
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    closeButtonRef.current?.focus();

    const handleKeyDown = (event) => {
      if (event.key === "Escape") onClose();
    };

    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
      document.body.style.overflow = previousOverflow;
      previouslyFocused?.focus?.();
    };
  }, [onClose]);

  return (
    <div className={styles.overlay} role="presentation" onMouseDown={(event) => {
      if (event.target === event.currentTarget) onClose();
    }}>
      <section className={styles.modal} role="dialog" aria-modal="true" aria-labelledby="faq-modal-title">
        <header className={styles.header}>
          <h2 id="faq-modal-title">FAQ</h2>
          <button ref={closeButtonRef} type="button" onClick={onClose} aria-label="Fechar FAQ">×</button>
        </header>

        <div className={styles.content}>
          <p className={styles.intro}>{FAQ_INTRO}</p>
          <div className={styles.list}>
            {FAQ_ITEMS.map((item) => (
              <details className={styles.item} key={item.question}>
                <summary>{item.question}</summary>
                <div className={styles.answer}>
                  {item.paragraphs.map((paragraph) => <p key={paragraph}>{paragraph}</p>)}
                  {item.items ? <ul>{item.items.map((entry) => <li key={entry}>{entry}</li>)}</ul> : null}
                  {item.groups?.map((group) => (
                    <section key={group.title}>
                      <strong>{group.title}</strong>
                      <ul>{group.items.map((entry) => <li key={entry}>{entry}</li>)}</ul>
                    </section>
                  ))}
                  {item.closing ? <p>{item.closing}</p> : null}
                </div>
              </details>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}

export default FaqModal;
